import {
  CertificationStatusChipOrIcon,
  CertificationStatusProps,
  CertificationWidgetProps,
  SiteUrlsContext,
} from '@tableau/data-catalog-shared';
import { DataQualityCertificationAssetFragment } from '@tableau/data-catalog-shared/lib/gen-src/queries/DataQualityCertificationAssetFragment';
import * as React from 'react';


import { DatabaseQuery_databases_DatabaseServer_dataQualityCertifications, DatabaseQuery_databases_CloudFile_dataQualityCertifications, DatabaseQuery_databases_File_dataQualityCertifications, DatabaseQuery_databases_WebDataConnector_dataQualityCertifications } from '../../../gen-src/queries/DatabaseQuery';
import { TableQuery_tables_DatabaseTable_dataQualityCertifications } from '../../../gen-src/queries/TableQuery';

export type PlaceHeaderMetadataCertificationProps =
  Omit<CertificationWidgetProps, 'icon'> &
  Pick<CertificationStatusProps, 'subjectArea'> & {
    readonly anchoredAsset: DataQualityCertificationAssetFragment;
    readonly vizportalId: string;
    dataQualityCertifications: DatabaseQuery_databases_DatabaseServer_dataQualityCertifications[] | DatabaseQuery_databases_CloudFile_dataQualityCertifications[] | DatabaseQuery_databases_File_dataQualityCertifications[] | DatabaseQuery_databases_WebDataConnector_dataQualityCertifications[] | TableQuery_tables_DatabaseTable_dataQualityCertifications[];
  };

/**
 * Renders the certification icon/popup alongside text showing the name of the certifier,
 * for use in place page headers.
 * @param props
 */
export function PlaceHeaderMetadataCertification(props: PlaceHeaderMetadataCertificationProps): JSX.Element | null {
  const urls = React.useContext(SiteUrlsContext);

  if (props.dataQualityCertifications.length > 0) {
    return (
      <CertificationStatusChipOrIcon
        kind={'graph'}
        urls={urls}
        iconOnly={false}
        subjectArea={props.subjectArea}
        anchoredAsset={props.anchoredAsset}
        anchoredCertifications={[{
          __typename: 'DataQualityCertification',
          vizportalId: props.vizportalId,
          author: props.dataQualityCertifications[0].author,
          authorDisplayName: props.dataQualityCertifications[0].author?.name ?? '',
          message: props.dataQualityCertifications[0].message,
          isActive: props.dataQualityCertifications[0].isActive,
          updatedAt: new Date(props.dataQualityCertifications[0].updatedAt)
        }]}
      />
    );
  } else {
    return null;
  }
}
